import { Component, OnInit, Input, OnChanges, ChangeDetectionStrategy } from '@angular/core';
import { Router } from '@angular/router';
import { Observable } from 'rxjs';

import { LoadingPanelService, LoadingPanelSettings } from '../shared/loading-panel/loading-panel.service';

import { ChartConfiguration, GridValue } from './models';
import { ChartService } from './services/chart.service';
import { ChartBase } from './chart-base';
import { DxResizableModule, DxDataGridModule } from 'devextreme-angular';
import { DxoTooltipModule, DxoPagingModule } from 'devextreme-angular/ui/nested';

@Component({
    templateUrl: './chart-grid.component.html',
    selector: 'ep-chart-grid',
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [DxResizableModule, DxDataGridModule, DxoTooltipModule, DxoPagingModule]
})

export class ChartGridComponent extends ChartBase implements OnChanges {

    constructor(private router: Router, private loadingPanelService: LoadingPanelService, private chartService: ChartService) { super(); }

    @Input() chartConfiguration: ChartConfiguration;

    isLoading = false;
    valueFields: GridValue[] = [];

    ngOnChanges(changes: any) {
        if (changes.chartConfiguration && this.chartConfiguration) {
            this.loadData();
        }
    }

    private loadData() {
        this.isLoading = true;
        this.chartService.getGridValues(this.chartConfiguration.ChartConfigurationId).then(result => {
            this.valueFields = result;
            this.isLoading = false;
        }).catch(() => { this.isLoading = false });
    }
}